import BaseModule from './BaseModule'

class Company extends BaseModule {
  constructor() {
    super()
  }
  // 获取收藏列表
  getCollectList(params){
    return this.post(`/api/cv/collect`, params, {
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    });
  }

  //取消收藏
  putCollect(params) {
    return this.put(`/api/position/cv/collect`, params);
  }

}

export default new Company()



// WEBPACK FOOTER //
// ./src/api/CollectionModule.js